import React from 'react'
import { object, string } from 'prop-types'
import styles from './MagazineLatestCTA.module.scss'
import SmartLink from '@/component/Primitive/SmartLink'

const MagazineLatestCTA = ({ title, to, magazineIssues }) => {
  const magazines = []
  for (const magazineIssue of magazineIssues) {
    const image = magazineIssue?.images?.cover_321x446_321?.[0]?.url
    magazines.push({
      image
    })
  }

  return (
    <div className={styles.MagazineLatestCTA}>
      <div className={styles.MagazineLatestCTAInner}>
        <div className={styles.MagazineLatestCTAImageHolder}>
          {magazines.map((magazineIssue, index) => (
            <img key={index} src={magazineIssue.image} alt="" />
          ))}
        </div>

        <SmartLink to={to} className={styles.MagazineLatestCTALink}>
          {title}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
          >
            <path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z" />
          </svg>
        </SmartLink>
      </div>
    </div>
  )
}

MagazineLatestCTA.propTypes = {
  title: string.isRequired,
  magazineIssues: object.isRequired,
  to: string.isRequired
}

export default MagazineLatestCTA
